import React from 'react';
import DateComponent from '/components/forms-v2/Date.component';

const DateOfBirthInput = ({ control }) => {
  return <DateComponent name='birthdayDate' control={control} label='Date of Birth' />;
};

export default DateOfBirthInput;
